<div class="header-mainInfo">
  <div style="line-height: 1.2; padding-top: 2px;">
    {{meetingType}} {{meetingTitle && meetingTitle.length > 0 ? "- " + meetingTitle : ""}}<br>
    <small class="opacity-medium" style="align-items: center; margin-right:12px;">
      <mat-icon class="md-14">calendar_today</mat-icon>{{meetingDate}}
    </small>
    <small class="opacity-medium" style="align-items: center; margin-right:12px;">
      <mat-icon class="md-14">access_time</mat-icon>{{meetingTime}}
    </small>
    <small class="opacity-medium" style="align-items: center; margin-right:12px;">
      <mat-icon class="md-14">access_time</mat-icon>{{meetingDuration}} min
    </small>
  </div>
</div>